import React from 'react';

interface Props {
  survey: any,
  clickedSurvey: any,
  surveyName: string,
}

class SurveyItem extends React.Component<Props, {}> {
  constructor(props) {
    super(props);
    this.clickedSurvey = this.clickedSurvey.bind(this);
  }

  clickedSurvey(e) {
    this.props.clickedSurvey(e);
  }

  render() {
    let { survey, surveyName } = this.props;
    return(
      <div className="p2 attendee-live-stream-item-wrapper flexbox-wrapper" onClick={this.clickedSurvey} data-survey-id={survey.id}>
        <div className="flexbox-item-small pr2">
          <div className="mr2 br5 cs-shadow-thick cs-gradient-blue event-survey-fa-icon-wrapper">
            <i className="flexbox-center fas fa-poll-h event-survey-fa-icon cs-white" />
          </div>
        </div>
        <div className="flexbox-item">
          <div className="cs-live-blue-alt fs-xs fw-b">{survey.surveyable_type} Survey</div>
          <div className="fs-md fw-sb cs-color-black">
            {surveyName}
          </div>
        </div>
      </div>
    );
  }
}

export default SurveyItem;
